import { useMemo } from 'react'
import { format, isAfter, isBefore } from 'date-fns'

export const useLocalDates = (dates: (string | null | undefined)[]) => {
  const localDates = useMemo(() => {
    return dates.map((date) => {
      if (!date) {
        return null
      }

      return new Date(date)
    })
  }, dates)

  return localDates
}

const getLocalDates = (dates: (string | null | undefined)[]) => {
  return dates.map((date) => {
    if (!date) {
      return null
    }
    return new Date(date)
  })
}

export const useLocalDatesWithFormat = (dates: (string | null | undefined)[], dateFormat: string) => {
  const localDates = useMemo(() => {
    return dates.map((date) => {
      if (!date) {
        return null
      }
      return format(new Date(date), dateFormat)
    })
  }, dates)

  return localDates
}

export const useIsHiddenFromDates = (
  start: string | null | undefined,
  end: string | null | undefined,
  dateToUse?: string | null,
) => {
  const [startDate, endDate, dateToUseDate] = useLocalDates([start, end, dateToUse])

  return useMemo(
    () =>
      (startDate && isBefore(dateToUseDate ?? new Date(), startDate)) ||
      (endDate && isAfter(dateToUseDate ?? new Date(), endDate)),
    [startDate, endDate],
  )
}

export const checkIsHiddenFromDates = (
  start: string | null | undefined,
  end: string | null | undefined,
  dateToUse: string | null | undefined,
) => {
  const [startDate, endDate, dateToUseDate] = getLocalDates([start, end, dateToUse])

  return (
    (startDate && isBefore(dateToUseDate ?? new Date(), startDate)) ||
    (endDate && isAfter(dateToUseDate ?? new Date(), endDate))
  )
}

export const atDateFormat = "dd/MM/yyyy 'at' hh:mm a"

export const getDateNow = () => new Date().toISOString()
